import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import AssignmentBtn from './components/AssignmentBtn';
import CopyMenuBtn from './components/CopyMenuBtn';
import ChangePositionBtn from './components/ChangePositionBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import CategorySelect from './components/CategorySelect';
import SubCategorySelect from './components/SubCategorySelect';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import UnassignedDishesCheckBox from './components/UnassignedDishesCheckBox';
import DishesInStopCheckBox from './components/DishesInStopCheckBox';
import ComboItemsSwitch from './components/ComboItemsSwitch';
import PriceFilter from './components/PriceFilter/PriceFilter';
import WithURLFilters from './components/WithURLFilters';
import style from './DishesControlPanel.module.scss';

const DishesControlPanel = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<AssignmentBtn />
				<CopyMenuBtn />
				<ChangePositionBtn />
			</div>
			<div className={style.selectWrapper}>
				<CustomerSelect />
				<RestaurantSelect />
				<CategorySelect />
				<SubCategorySelect />
			</div>
			<div className={style.secondRowWithControls}>
				<UnassignedDishesCheckBox />
				<DishesInStopCheckBox />
				<ComboItemsSwitch />
				<PriceFilter />
			</div>
			<div className={style.verticalAlignBlock}>
				<ResetBtn />
				<SortBy />
				<CountOfItem />
			</div>
		</WithURLFilters>
	);
};

export default DishesControlPanel;
